'use strict';

var _errorStackParser = require('error-stack-parser');

var _errorStackParser2 = _interopRequireDefault(_errorStackParser);

var _stackGenerator = require('stack-generator');

var _stackGenerator2 = _interopRequireDefault(_stackGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// https://github.com/stacktracejs/stacktrace.js/blob/master/stacktrace.js
var generateError = function stacktrace$$generateError() {
    try {
        // Error must be thrown to get stack in IE
        throw new Error();
    } catch (err) {
        return err;
    }
};

var isShapedLikeParsableError = function stacktrace$$isShapedLikeParsableError(err) {
    return err.stack || err['opera#sourceloc'];
};

module.exports = {
    get: function stacktrace$$get(options) {
        var err = generateError();
        var stackframes = isShapedLikeParsableError(err) ? _errorStackParser2['default'].parse(err) : _stackGenerator2['default'].backtrace(options);
        return stackframes;
    }
};


//////////////////
// WEBPACK FOOTER
// ../~/universal-logger/lib/stacktrace.js
// module id = ../node_modules/universal-logger/lib/stacktrace.js
// module chunks = 0